import React from 'react';
import { Helmet } from 'react-helmet-async';
import LegalPageLayout from './LegalPageLayout';

const TermsPage = () => (
  <LegalPageLayout title="Pogoji sodelovanja" eyebrow="Pravno obvestilo" testid="terms-page">
    <Helmet>
      <title>Pogoji sodelovanja – Val Dotika</title>
      <meta name="description" content="Pogoji prijave in sodelovanja ter izjava o odgovornosti za tečaje društva Val Dotika." />
    </Helmet>

    <h2 className="font-serif text-2xl text-stone-800 font-bold pt-2">Pogoji prijave in sodelovanja</h2>

    <p>
      Prijava na tečaj ali delavnico poteka preko zasebnega sporočila (ZS) na naših družbenih omrežjih ali preko elektronske pošte.
    </p>

    <p>
      Prijava se šteje za dokončno in potrjeno šele v trenutku, ko je izvedeno plačilo prispevka za delavnico (razen pri brezplačnih dogodkih). Do takrat je mesto le v čakalni vrsti.
    </p>

    <p>
      Zaradi zagotavljanja kakovosti dela in intimnega vzdušja je število mest na delavnicah omejeno na največ 5 mamic z dojenčki.
    </p>

    <p>
      Udeleženka lahko odpove udeležbo do 3 dni pred terminom. Pri odpovedi se vplačani znesek ne vrača, lahko pa se udeleženka dogovori za nadomestni termin (če je to mogoče glede na razpoložljivost mest) ali svoje mesto preda drugi osebi.
    </p>

    <p>
      Društvo si pridržuje pravico do odpovedi delavnice v primeru bolezni izvajalke ali premalega števila prijav. Če delavnico odpovemo mi, vam vplačilo vrnemo v celoti v roku 8 dni.
    </p>

    <p>
      Na delavnicah se občasno fotografirajo utrinki za potrebe promocije društva na socialnih omrežjih. Fotografije ne bodo uporabljene na način, ki bi škodoval dostojanstvu udeležencev. O fotografiranju boste obveščeni na mestu samem, kjer lahko kadarkoli izrazite željo po neobjavi fotografij vas ali vašega otroka.
    </p>

    <h2 className="font-serif text-2xl text-stone-800 font-bold pt-4">Izjava o odgovornosti</h2>

    <p>
      Ponujene storitve so namenjene sprostitvi, preventivi in izobraževanju. Niso zdravstvena storitev in ne nadomeščajo strokovne medicinske obravnave, diagnoze ali zdravljenja.
    </p>

    <p>
      V primeru kakršnih koli zdravstvenih težav ali specifičnih stanj vašega otroka se morate pred obiskom delavnice posvetovati z izbranim pediatrom.
    </p>

    <p>
      Sodelovanje na vseh aktivnostih poteka na lastno odgovornost starša oziroma skrbnika. Starš je dolžan spremljati odzive otroka in izvajati tehnike z občutkom. Društvo ne prevzema odgovornosti za morebitne neželene reakcije, ki bi nastale zaradi nepravilnega izvajanja tehnik doma ali neupoštevanja navodil izvajalke.
    </p>
  </LegalPageLayout>
);

export default TermsPage;
